const session_expired = {
    title: 'Sessão expirada',
    subtitle: 'A sua sessão pode ter expirado  foi desconectado. Clique no botão abaixo para fazer login novamente.',
    button: 'Entrar novamente',
};
export default session_expired;
